<template>
    <label class="pp-input"
        :class="[
            'pp-input--' + currentSize,
            { 'pp-input--suffix': hasSuffix, 
              'pp-input--prefix': hasPrefix ,
              'is-disabled': currentDisabled,
            }
        ]">
        <div v-if="hasPrefix" class="pp-input__prefix">
            <slot name="prefix"></slot>
        </div>
        <input ref="input" class="pp-input__inner" 
            v-bind="$attrs"
            v-model="currentValue" 
            :disabled="currentDisabled"
            :readonly="readonly"
            @select="handleSelect"
            @change="handleChange"
            @focus="handleFocus"
            @blur="handleBlur"/>
        <div v-if="hasSuffix || clearable" class="pp-input__suffix">
            <i v-if="showClear && !readonly" class="pp-icon-close-circle" @click="clear"></i>
            <slot name="suffix"></slot>
        </div>
    </label>
</template>

<script>
import EventBus from '../../../src/util/event-bus.js'

/**
 * input
 * @param {[string, number]} value v-model
 * @param {string} size 尺寸[normal(default), small, mini]
 * @param {boolean} disabled 禁用状态
 * @param {boolean} clearable 清除按钮
 * @param {boolean} readonly 只读状态
 * 
 * @event focus return event
 * @event blur return event
 * @event change return { event, value }
 * @event select return event
 * @event clear no return (only has param clearable)
 * 
 * @method focus control input focus
 * @method blur control input blur
 * @method select control input select 
 * @method clear reset input value = '' (only has param clearable)
 */
export default {
    name: 'pp-input',
    inheritAttrs: false,
    inject: {
        Form: {
            default: ''
        },
        FormItem: {
            default: ''
        },
    },
    props: {
        value: [String, Number],
        size: {
            type: String,
            default: 'normal',
        },
        disabled: Boolean,
        clearable: Boolean,
        readonly: Boolean,
    },
    data: function() {
        return {
            currentValue: '',
            isFocus: false,
        };
    },
    computed: {
        currentSize: function() {
            return this.Form.size || this.FormItem.size || this.size;
        },
        hasPrefix: function() {
            return !!this.$slots.prefix;
        },
        hasSuffix: function() {
            return !!this.$slots.suffix;
        },
        showClear: function() {
            return this.clearable /*&& this.isFocus */&& !!this.currentValue;
        },
        currentDisabled: function() {
            return this.Form.disabled || this.disabled;
        },
    },
    watch: {
        currentValue: function(n, o) {
            this.$emit('input', n)
        },
        value: function(n, o) {
            this.currentValue = n
        },
    },
    mounted: function() {
        this.currentValue = this.value;
    },
    methods: {
        handleChange: function() {
            this.$emit('change', this.currentValue)
            
            EventBus.formItemTrigger.apply(this, ['change', this.currentValue])
        },

        handleFocus: function() {
            this.isFocus = true
            this.$emit('focus', this.currentValue)
        },

        handleBlur: function() {
            this.isFocus = false
            this.$emit('blur', this.currentValue)

            EventBus.formItemTrigger.apply(this, ['blur', this.currentValue])
        },

        handleSelect: function(e) {
            this.$emit('select', e)
        },

        focus: function() {
            this.$refs['input'].focus()
        },

        blur: function() {
            this.$refs['input'].blur()
        },

        select: function() {
            this.$refs['input'].select()
        },

        clear: function() {
            this.currentValue = ''
            this.$emit('clear')
            this.handleChange()
        },
    },
}
</script>
